<app-loading *ngIf="contentReady"></app-loading>

<section
  class="bb-page delivery-ticket-page"
  [class.rtl]="isAr"
  [attr.dir]="isAr ? 'rtl' : 'ltr'"
>
  <div class="bb-page-shell delivery-ticket-shell">

    <!-- Header -->
    <header class="delivery-mobile-hero">
      <div class="delivery-hero-copy">
        <span class="bb-eyebrow">
          {{ "delivery fees" | transloco }}
        </span>

        <h2>
          {{ "Manage delivery prices by governorate" | transloco }}
        </h2>

        <p>
          {{ visibleData.length || 0 }} / {{ allData.length || 0 }}
          {{ "Governorate" | transloco }}
        </p>
      </div>

      <div class="delivery-hero-icon">
        <i class="fa-solid fa-truck-fast" aria-hidden="true"></i>
      </div>
    </header>

    <!-- Add Form -->
    <section class="delivery-form-ticket">
      <div class="delivery-form-head">
        <div>
          <span class="bb-eyebrow">
            {{ "Submit" | transloco }}
          </span>

          <h3>
            {{ "delivery fees" | transloco }}
          </h3>
        </div>
      </div>

      <form [formGroup]="priceForm" (ngSubmit)="addItem()">

        <div class="delivery-form-grid">

          <div class="bb-field">
            <label class="bb-label">
              {{ "Governorate" | transloco }}
            </label>

            <select
              formControlName="governorate_id"
              class="bb-input delivery-select"
            >
              <option value="">
                {{ "Select Governorate" | transloco }}
              </option>

              <option *ngFor="let gov of governorates" [value]="gov.id">
                {{ isAr ? gov.governorate_name_ar : gov.governorate_name_en }}
              </option>
            </select>
          </div>

          <div class="bb-field">
            <label class="bb-label">
              {{ "delivery fees" | transloco }}
            </label>

            <input
              type="number"
              formControlName="price"
              class="bb-input"
              placeholder="0"
              min="0"
            />
          </div>

        </div>

        <div class="delivery-form-actions">
          <button
            type="submit"
            class="bb-btn bb-btn-primary"
            [disabled]="priceForm.invalid || submitting"
          >
            <i
              class="fa-solid"
              [class.fa-plus]="!submitting"
              [class.fa-spinner]="submitting"
              [class.fa-spin]="submitting"
              aria-hidden="true"
            ></i>

            <span>
              {{ submitting ? ("loading" | transloco) : ("Submit" | transloco) }}
            </span>
          </button>
        </div>

      </form>
    </section>

    <!-- Cards List -->
    <section class="delivery-ticket-list" *ngIf="visibleData.length > 0">

      <article
        class="delivery-fee-ticket"
        *ngFor="let element of visibleData; trackBy: trackById"
      >

        <!-- Top -->
        <div class="delivery-fee-top">

          <div class="delivery-fee-main">
            <div class="delivery-fee-avatar">
              <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
            </div>

            <div class="delivery-fee-copy">
              <span>
                {{ "Governorate" | transloco }}
              </span>

              <h3>
                {{
                  isAr
                    ? element.governorate?.governorate_name_ar
                    : element.governorate?.governorate_name_en
                }}
              </h3>
            </div>
          </div>

          <div class="delivery-price-badge">
            <span>
              {{ "delivery fees" | transloco }}
            </span>

            <strong>
              {{ element.price }} {{ 'ج.م' | transloco }}
            </strong>
          </div>

        </div>

        <!-- Details -->
        <div class="delivery-fee-details">

          <div class="delivery-detail-chip">
            <i class="fa-solid fa-map-location-dot" aria-hidden="true"></i>

            <span>
              {{ "Governorate" | transloco }}
            </span>

            <strong>
              {{
                isAr
                  ? element.governorate?.governorate_name_ar
                  : element.governorate?.governorate_name_en
              }}
            </strong>
          </div>

          <div class="delivery-detail-chip">
            <i class="fa-solid fa-money-bill-wave" aria-hidden="true"></i>

            <span>
              {{ "delivery fees" | transloco }}
            </span>

            <strong class="delivery-money-value">
              {{ element.price }} {{ 'ج.م' | transloco }}
            </strong>
          </div>

        </div>

      </article>

    </section>

    <!-- No Data -->
    <div class="bb-empty-state bb-text-center" *ngIf="noData && !contentReady">
      <app-nodata></app-nodata>
    </div>

    <!-- Loading More -->
    <div class="delivery-mobile-loader" *ngIf="loadingMore">
      <span aria-hidden="true"></span>
      <strong>{{ "loading" | transloco }}</strong>
    </div>

    <!-- End Message -->
    <div
      class="delivery-end-state"
      *ngIf="!noData && visibleData.length >= allData.length && allData.length > pageSize"
    >
      {{ "No more data" | transloco }}
    </div>

  </div>
</section>